const validatorRuleEmail = {
    email: ['required', 'email'],
};
export default validatorRuleEmail;
